import { Http } from '../../utils/types'
import { Format, GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { formatDepartmentWithoutConfig } from './format/departmentWithoutConfig'
import { GetAllDepartments, GetAllDepartmentsWithFilter, ResponseAmountUser, ResponseDepartment, ResponseDepartmentId } from './response'
import { DepartmentWithoutConfig } from './responses'

export const departmentService = (client: Http) => ({
  getAllDepartments: async (): Promise<GetAllDepartments> => await client.get('department'),
  getAllDepartmentsWithFilter: async (query?: string): Promise<GetAllDepartmentsWithFilter> => {
    return await client.get(`department/detailed${query ? '?' + query : ''}`)
  },
  getDepartmentWithoutConfig: async ({ areasIds = [] }: { areasIds: string[] }): Format<DepartmentWithoutConfig> => {
    if (!areasIds.length) { return { data: [], item: [] } }
    const response = await client.get<DepartmentWithoutConfig>(`department/without-config?areas_ids=${areasIds.join(',')}`)
    return formatDepartmentWithoutConfig({ response })
  },
  createDepartment: async (body: ObjectGeneric): Promise<ResponseDepartment> => await client.post('department', body),
  updateDepartment: async (body: ObjectGeneric, id: number): Promise<ResponseDepartment> => await client.put(`department/${id}`, body),
  permissionDepartment: async (body: ObjectGeneric, id: number): Promise<ResponseDepartment> => await client.put(`department/${id}/associate-users`, body),
  deleteDepartment: async (id: number): Promise<ResponseDepartment> => await client.delete(`department/${id}`),
  getDepartmentById: async (id?: number): Promise<ResponseDepartmentId> => await client.get(`department/${id}`),
  getAllUsers: async (): Promise<any> => await client.get('users/not-assigned-department'),
  getCountUserJerarquia: async (query: { query: string }): Promise<ResponseAmountUser> => await client.get(`users/users-count${query.query ? `?${query.query}` : ''}`),
  downloadFile: async (data: {
    type: string
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `department/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
    ),
})
